import { StateCreator } from "zustand"
import { StoreType } from "./AppStore"

export type AvisoPedidoStore = {
    getAvisoElement: () => HTMLAudioElement | null
    ativarAviso: () => void
    desativarAviso: () => void
    toggleAviso: () => void
}

const createAvisoPedidoStore: StateCreator<StoreType, [], [], AvisoPedidoStore> = (set, get) => ({
    getAvisoElement: () => document.getElementById("audiopedido") as HTMLAudioElement,
    ativarAviso: () => {
        if (!get().configuracoes!.recebedor.efeitoSonoro) return

        get().getAvisoElement()?.play()

        if (get().configuracoes!.recebedor.aceitarPedidoAutomatico)
            setTimeout(get().desativarAviso, get().configuracoes!.recebedor.duracaoEfeitoSonoro ?
                Number(get().configuracoes!.recebedor.duracaoEfeitoSonoro) * 1000 : 5000
            )
    },
    desativarAviso: () => get().getAvisoElement()?.pause(),
    toggleAviso: () => {
        const elementoAudio = get().getAvisoElement()

        if (!elementoAudio) return

        elementoAudio.paused ? elementoAudio.play() : elementoAudio.pause()
    }
})

export default createAvisoPedidoStore
